import { useContext, useEffect, useState } from 'react'

import { Box, Button, Link } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { CONTENT_TYPES } from '@scoir/college-content'
import { MultiSectionDialog } from '@scoir/modals'

import ModalError from 'components/ModalError'

import ContentManagementContext from '../../../ContentManagementProvider/Context'
import ContentModalContext from '../ContentModalProvider/Context'
import { FIELD_NAMES } from '../components/constants'
import Academics from './Academics'
import Admissions from './Admissions'
import Audience from './Audience'
import ContentType from './ContentType'
import Financial from './Cost_Aid'
import Details from './Details/index'
import HiddenSwitch from './HiddenSwitch'
import Type from './Type'

const ContentEditModal = () => {
  const {
    type,
    show,
    item,
    onHideModal,
    onDeleteItem,
    onSaveItem,
    isEditing,
    isCopying,
    validation,
    selectedAcademicFocuses,
    selectedCategories,
    exceed5Tags,
    setExceed5Tags,
  } = useContext(ContentModalContext)
  const { saveContentLoading, saveContentError } = useContext(ContentManagementContext)
  const isPostContent = type !== CONTENT_TYPES.PROGRAMS && type !== CONTENT_TYPES.SESSIONS
  const exceed5TagsError = !isPostContent && exceed5Tags
  const imageError = isPostContent && !item[FIELD_NAMES.IMAGE_URL]
  const canSave = !saveContentLoading && !validation.hasErrors && !exceed5TagsError && !imageError
  const [confirmDelete, setConfirmDelete] = useState(false)

  const isPost = type !== CONTENT_TYPES.PROGRAMS && type !== CONTENT_TYPES.SESSIONS

  const headerTextType = () => {
    switch (type) {
      case CONTENT_TYPES.SESSIONS:
        return 'Event'
      case CONTENT_TYPES.PROGRAMS:
        return 'Program'
      default:
        return 'Post'
    }
  }

  const getModalAction = () => {
    if (isCopying) return 'Copy'
    if (isEditing) return 'Edit'
    return 'New'
  }

  const headerText = `${getModalAction()} ${headerTextType()}`

  useEffect(() => {
    const categoriesLength = selectedCategories?.length || 0
    const academicFocusesLength = selectedAcademicFocuses?.length || 0
    setExceed5Tags(categoriesLength + academicFocusesLength > 5)
  }, [selectedAcademicFocuses?.length, selectedCategories?.length, setExceed5Tags])

  return (
    <MultiSectionDialog
      open={show}
      onClose={onHideModal}
      scroll="paper"
      headerText={headerText}
      headerChildren={<HiddenSwitch />}
    >
      <MultiSectionDialog.Body>
        <Box
          display="flex"
          flexDirection="column"
          gridGap={24}
        >
          <Alert severity="info">
            Scoir automatically adds tracking parameters (UTMs) to links in this content unless you add your own.{' '}
            <Link
              href="https://scoir.helpdocs.io/article/ho5zad2vh2-for-colleges-understanding-scoir-data-in-your-crm#utm_parameters"
              target="_blank"
              rel="noreferrer"
            >
              Learn more
            </Link>
          </Alert>
          <Details />
          {isPost ? <ContentType /> : <Type />}
          {(type === CONTENT_TYPES.SESSIONS || isPost) && <Audience />}
          {type === CONTENT_TYPES.PROGRAMS && (
            <>
              <Academics />
              <Admissions />
              <Financial />
            </>
          )}
        </Box>
      </MultiSectionDialog.Body>
      <MultiSectionDialog.Footer>
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
        >
          {saveContentError && <ModalError />}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              variant="text"
              color="primary"
              onClick={onHideModal}
            >
              Cancel
            </Button>
            <Box
              display="flex"
              gridGap={8}
            >
              {isEditing && !confirmDelete && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setConfirmDelete(true)}
                >
                  Delete
                </Button>
              )}
              {isEditing && confirmDelete && (
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={onDeleteItem}
                >
                  Confirm Delete
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                disabled={!canSave}
                onClick={onSaveItem}
              >
                {item[FIELD_NAMES.IS_HIDDEN] ? 'Save as Hidden' : 'Save & Publish'}
              </Button>
            </Box>
          </Box>
        </Box>
      </MultiSectionDialog.Footer>
    </MultiSectionDialog>
  )
}

export default ContentEditModal
